/**
 * 是不是一个可以安全交给浏览器跳转的绝对地址。
 *
 * 结账按钮要跳去网关（收银台或 PayPal 授权页），目标地址是服务端拼出来的，
 * 但它毕竟经过了一次网络往返 —— 只要它被换掉，页面就会把用户送去任意站点。
 * 所以跳转前只认 `http:` / `https:` 两种协议，别的一律当失败处理（`javascript:`
 * 和 `data:` 尤其危险）。
 */
export const isHttpUrl = (raw: string): boolean => {
  let url: URL
  try {
    url = new URL(raw)
  } catch {
    return false
  }
  return url.protocol === "http:" || url.protocol === "https:"
}

/**
 * 把整页送去网关。返回 false 表示这个目标不可信、什么都没做，调用方负责报错。
 *
 * 单独一个函数是为了两件事：把「校验 + 跳转」这一对锁在一起，任何地方都
 * 不可能绕过校验直接改 `location`；以及让界面测试能只断言「跳哪儿」，不必
 * 在 jsdom 里和只读的 `window.location` 搏斗。
 */
export const navigateToExternal = (target: string): boolean => {
  if (!isHttpUrl(target)) return false
  window.location.assign(target)
  return true
}
